import { COLORS } from '@/theme';
import styled from 'styled-components';

export const StyledHint = styled('div')`
  display: flex;
  color: ${COLORS.TEXT_HINT};
  gap: 0.5rem;
`;
